import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { ApifirstService } from 'src/app/service/apifirst.service';
import { RpcClientService } from 'src/app/service/rpc-client.service';

@Component({
  selector: 'app-network-test',
  templateUrl: './network-test.component.html',
  styleUrls: ['./network-test.component.scss'],
  providers: [NgbModalConfig, NgbModal]

})
export class NetworkTestComponent implements OnInit {

  progressbar: boolean = false;
  public isNetwork = false;
  isShowOverRide: boolean = false;
  public res: any;
  public vin: string = '';
  public country: string = '';
  public lang: string = '';
  public userId: string = ''
  market: any;
  maxFailureTimes: number = 0;
  public userType: any;
  userTypeId: any;
  public isShowOverrideBlock: boolean = false;
  public isShowTestProgressBlock: boolean = false;
  public isFDRSConnected: boolean = false;
  public isNetworkTestError: boolean = false;
  public isNWTestFailedMultiple: boolean = false;
  public isNWTestFailedAdmin: boolean = false;
  public isUserAdmin: boolean = false;
  public isNetworkFailure: boolean = false;
  public retryNetworkTestCount: number = 1;
  networkTestErrorMsg: string = '';
  dealerCode: any;
  @ViewChild('NWTTestErrorInfo') NWTTestErrorInfo: ElementRef | undefined;
  resumeNWTStatus: Subscription = new Subscription
  // public isShowReRunBlock: boolean = false;
  @ViewChild('FDRSClosedAlert') FDRSClosedAlert: ElementRef | undefined;
  reasonKey="";
  constructor(private rpcClientService: RpcClientService, private service: ApifirstService, public router: Router, private modalService: NgbModal, config: NgbModalConfig) { }

  ngOnInit(): void {
    this.service.tokenObj.subscribe((data) => {
      this.res = data;
      this.vin = this.res.vin;
      this.country = this.res.country;
      this.lang = this.res.language;
      this.userType = this.res.userType
      this.market = this.res.marketCountry
      this.dealerCode = this.res.dealerCode;
      if (Object.keys(data).length !== 0) {
        if (this.userType == 'FORD_INTERNAL') {
          this.userTypeId = 1
        } else if (this.userType == 'PTS_DEALER') {
          this.userTypeId = 3;
        } else if(this.userType == 'PTS_AFTERMARKET') {
          this.userTypeId = 2;
        }
      }
    })

    this.getNetworkTestFailureAttempts()

    this.service.isFDRSConnection.subscribe((data: boolean) => {
      this.isFDRSConnected = data;
    })

    this.service.showSBDAdminTab.subscribe((data) => {
      this.isUserAdmin = data;
    })

    if (this.isUserAdmin && this.isFDRSConnected) {
      this.isShowOverrideBlock = true;
    } else {
      if (!this.isUserAdmin && this.isFDRSConnected) {
        this.startNetworkTest();
      }
    }

    this.resumeNWTStatus = this.service.isFDRSNetworkTest$.subscribe((data: any) => {
      if (data.status) {
        this.service.isNetworkTestCompletedFromResume.next(true);
        this.isNetwork = data.status;
        let obj = {
          "sessionID": localStorage.getItem("sessionID"),
          "vin": this.vin
        }
        //this.service.isNWTInProgress.next(false);
        this.service.postNetworkTest(obj).subscribe((data) => {
          this.service.captureEvisDataDetails(this.vin, this.lang, this.country, localStorage.getItem("sessionID"), this.userId).subscribe((data) => {
          }, (error) => {
            this.router.navigate(['/info'])
          })
        })

        this.service.userId.subscribe((data) => {
          this.userId = data;
        })
        console.log('network test finished')
      } else {
        // Network test error
        // console.log("Called:", this.retryNetworkTestFlag);
        this.networkTestErrorMsg = data.reason;
        console.log("data reason",data.reason)
        this.modalService.open(this.NWTTestErrorInfo, { size: 'lg' });
        this.isNetworkFailure = true;
        if (data.reason == "Unable to communicate to the vehicle. Make sure the Ignition is turned ON and that the DLC and USB connections are OK. If Ok then go to the Menu-Device Manager and verify you are connecting to the appropriate VCI Device. ") {
          this.reasonKey = "1004";
        }
        else if(data.reason=="Unable to read vins"){
          this.reasonKey="1003"
        }
        else if(data.reason=="Lost communication to vehicle"){
          this.reasonKey="1005"
        }
        else if(data.reason=="VIN Mismatch"){
          this.reasonKey="1006"
        }
        else {
          this.reasonKey = data.reason
        }
        const vinDetails = this.service.getVinDetailsSnapshot();
        console.log("vinDetails",vinDetails)

        let reportdto={
          "vin": this.vin,
          "id": this.reasonKey,
          "vehicleType":vinDetails?.vehicleLineDescription,
          "market": this.market,
          "dealerCode":this.dealerCode,
          "gnumber":"not applicable"
        }
        this.service.reportdetails(reportdto).subscribe((data)=>{});

        if (this.isUserAdmin) {
          setTimeout(() => {
            console.log("Admin fail called");
            this.isShowOverrideBlock = false;
            this.isShowTestProgressBlock = false;
            this.isNWTestFailedMultiple = false;
            this.isNetworkTestError = false;
            this.isNWTestFailedAdmin = true;
            this.service.setShowWhatsNew(true);
            // this.service.isNWTInProgress.next(false);
          }, 5000);
        } else {
          if (this.retryNetworkTestCount > this.maxFailureTimes) {
            setTimeout(() => {
              this.isShowOverrideBlock = false;
              this.isShowTestProgressBlock = false;
              this.isNWTestFailedMultiple = true;
              this.isNetworkTestError = false;
              this.isNWTestFailedAdmin = false;
              //this.service.isNWTInProgress.next(false);
            }, 5000)
          } else {
            setTimeout(() => {
              this.isNetwork = data;
              this.progressbar = false;
              this.isNetworkTestError = true;
              this.isShowTestProgressBlock = false;
              //this.service.isNWTInProgress.next(false);
            }, 5000)
          }
        }
      }
    })
  }

  getNetworkTestFailureAttempts() {
    this.service.getReRunNetworkTestConfiguration(this.userTypeId, this.market).subscribe((data: any) => {
      console.log("from Resume Component: rerunconfig:", data);
      this.maxFailureTimes = data;
    })
  }

  startNetworkTest() {
    this.progressbar = true;
    this.isShowOverrideBlock = false;
    this.isShowTestProgressBlock = true;
    this.rpcClientService.runNetworkTest("", "");
    //this.service.isNWTInProgress.next(true);
    this.service.setShowWhatsNew(true);
  }

  retryNetworkTest() {
    this.retryNetworkTestCount = this.retryNetworkTestCount + 1;
    // this.retryNetworkTestFlag = 'Yes'
    this.isNetworkFailure = false;
    this.progressbar = true;
    this.isNetwork = false;
    this.isShowTestProgressBlock = true;
    this.isNetworkTestError = false;
    this.isNWTestFailedAdmin = false;
    this.isNWTestFailedMultiple = false;
    //this.service.isNWTInProgress.next(true);
    this.rpcClientService.runNetworkTest("", "");
    this.service.setShowWhatsNew(true);
  }

  overrideBtnClicked() {
   // this.service.isNWTInProgress.next(false);
    this.service.setShowWhatsNew(false);
    let obj = {
      "sessionID": localStorage.getItem("sessionID"),
      "vin": this.vin
    }
    this.service.postNetworkTest(obj).subscribe((data) => {
      this.router.navigate(['/info']);
    })

  }
  ngOnDestroy() {
    this.resumeNWTStatus.unsubscribe();
  }
}
